import { useAxiosPrivate } from "./axios";

const LIST_WORKERS_QUERY = "/user/workers";

export const useSearchWorkers = () => {
  const searchWorkers = async (callback) => {
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.get(LIST_WORKERS_QUERY, {
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return searchWorkers;
};
